import { useSelector } from 'react-redux';

import { RootState } from 'src/app/store';
import {
  RunBambiRunRead,
  RunBambiRunWrite,
  useRunBambiRunApplyCreateMutation,
  useRunBambiRunCreateMutation,
} from 'src/common/external/bambi-api/bambiApi';

import { makeDispatchTimeRange } from '../makeDispatchTimeRange';

export function useRunBambiRun() {
  const { selectedDate } = useSelector((state: RootState) => state.dispatcher);
  const [startImpl] = useRunBambiRunCreateMutation();
  const [applyImpl] = useRunBambiRunApplyCreateMutation();
  const dispatchTimeRange = makeDispatchTimeRange(selectedDate);

  return {
    start: ({
      tripIds,
      assignments,
    }: {
      tripIds: string[];
      assignments: string[];
    }) => {
      // A little hand-waving here since the create type is
      // being generated with id as required
      // Create a type to ensure we're getting the actual required params
      // before casting at the api client boundary to RunBambiRun
      // See https://github.com/bambi-health/bambi/pull/658#discussion_r1114868602
      // TODO: fix up spec to generate the create body type without the id param
      const runBambiRun: Omit<RunBambiRunRead, 'id'> = {
        range_start: dispatchTimeRange.start,
        range_end: dispatchTimeRange.end,
        trips: tripIds,
        assignments,
      };

      return startImpl({
        runBambiRun: runBambiRun as RunBambiRunWrite,
      });
    },
    apply: ({
      runBambiRunJobId,
      excludedTripIds,
    }: {
      runBambiRunJobId: string;
      excludedTripIds: string[];
    }) => {
      return applyImpl({
        id: runBambiRunJobId,
        runBambiRunApply: {
          excluded_trips: excludedTripIds,
        },
      });
    },
  };
}
